import type { ReactNode } from 'react';

import { RoleRequired } from '@/components/common/RoleRequired';
import { env } from '@/env';
import { useLogtoRoles } from '@/hooks/useLogtoRoles';
import { hasAnyRole } from '@/lib/roleRevalidation';

/**
 * Il gate delle rotte di CREAZIONE e SPESA sugli avatar: passa chi ha ALMENO UNO dei ruoli creatore (`env.avatarCreatorRoles`), non `administrator` fisso.
 * Come `RoleGate`, ma su un insieme; chi non passa vede lo stesso pannello «Ricontrolla», mai il vuoto. Il flag Studio lo decide il router (`soloCreatoriConStudio`).
 */
export function CreatoreGate({ children }: { children: ReactNode }) {
  const ruoli = useLogtoRoles();
  if (hasAnyRole(ruoli, env.avatarCreatorRoles)) return <>{children}</>;
  return <RoleRequired role={env.avatarCreatorRoles.join(' / ')} />;
}
